export default "<ion-app [class.desktop]=\"config.isWebApp\">\n  <ion-router-outlet></ion-router-outlet>\n</ion-app>\n";